import { FC } from "react";
import { Box, Typography } from "@material-ui/core";
import { useStyles } from "./style";
import { InfoBox } from "componentsNew/elements/InfoBox";
import { daRoles, daScheduleRoleIdToKey, daScheduleRoleKeyToId } from "mocks/roleDA";
import { CalendarData } from "types/DaHome";
import { useScheduleCellTheme } from "hooks/useTheme";

interface PropsType {
  scheduleData: CalendarData | undefined;
}

const CalendarDetails: FC<PropsType> = ({ scheduleData }) => {
  const classes = useStyles();
  const { theme } = useScheduleCellTheme(scheduleData);

  return (
    <Box className={classes.contentBox}>
      {scheduleData ? (
        <Box className={classes.detailsBox}>
          <Box className={`${classes.roleBox} ${theme.backgroundClass}`}>
            <Typography className={`${theme.colorClass} ${classes.roleText}`}>
              {returnRole(scheduleData?.role)}
            </Typography>
          </Box>
          <Box className={classes.bottomDetails}>
            <Box className={classes.descBox}>
              <InfoBox label={"Station"} value={scheduleData?.station__title} />
              <InfoBox
                label={"Start at"}
                value={scheduleData ? scheduleData?.shift_start_time : ""}
              />
            </Box>
          </Box>
        </Box>

      ) : (
        <Typography>No schedule</Typography>
      )}
    </Box>
  );
};

const returnRole = (role: number | undefined) => {
  if (role === undefined) return "Available";
  if (
    role === daScheduleRoleKeyToId.mycuCancelled ||
    role === daScheduleRoleKeyToId.clientCancelled
  )
    return "Cacelled";
  return daRoles[daScheduleRoleIdToKey[role]]?.name || "Available";
};

export default CalendarDetails;
